import React, { useState, useContext, useEffect, useRef } from 'react';
import { useField, useFormikContext } from 'formik';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { PlaceStoreContext } from '../reducers/Place/PlaceContext';

export const EditCategory = ({ multiple, label, disabled, ...props }) => {
  const [placeState] = useContext(PlaceStoreContext);
  const {
    categories: { categoryId__category },
    services: { serviceId__service },
  } = placeState;

  const [field, meta] = useField(props);
  const { values, setFieldValue } = useFormikContext();
  const serviceId = values.serviceId ? values.serviceId : categoryId__category[values.category].service_id;
  const service = serviceId__service[serviceId];
  const groupsOnly = values.group === 'nested';
  const selected = categoryId__category[values.id] && categoryId__category[values.id].nested
    ? categoryId__category[values.id].nested
    : null;

  const serviceIdRef = useRef(serviceId);

  const [availableCategories, setAvailableCategories] = useState(null);

  useEffect(() => {
    const categories = [];
    for (const categoryId in categoryId__category) {
      if (categoryId === values.id) continue;
      if (groupsOnly && !categoryId__category[categoryId].group) {
        continue;
      } else if (!groupsOnly && categoryId__category[categoryId].group) {
        continue;
      };
      categoryId__category[categoryId].service_id === serviceId &&
        categories.push(categoryId__category[categoryId]);
    }

    setAvailableCategories(categories.sort((a, b) => a.name.localeCompare(b.name)));
    if (serviceIdRef.current !== serviceId) {
      setFieldValue(field.name, '');
    }
  }, [placeState, serviceId]);

  if (!availableCategories) return null;

  const noCategoriesAvailable = availableCategories.length === 0 || availableCategories.length === 1 && availableCategories[0].id === 'new';

  return (
    <TextField
      fullWidth
      select
      disabled={noCategoriesAvailable}
      SelectProps={{
        multiple,
      }}
      variant="outlined"
      label={noCategoriesAvailable ? `No ${selected || !categoryId__category[values.category]?.name ? service.name : categoryId__category[values.category].name} categories found` : label}
      defaultValue={selected}
      helperText={meta.touched && meta.error}
      error={meta.touched && !!meta.error}
      {...field}
      {...props}
    >
      {availableCategories.map((category) => {
        return (
          <MenuItem key={category.id} value={category.id}>
            {category.name}
          </MenuItem>
        );
      })}
    </TextField>
  );
};
